<!-- eslint-disable max-len -->
<template>
  <div>
    <h4>ROLE</h4>

    <div
      v-for=" (item, index) in dataRole"
      :key="index"
      class="container-roles d-flex">
      <j-toggle
        v-model="item.status"
        :disabled="readOnly"
        class="m__r--55"/>
      {{ item.roles_name.replace('_', ' ').toUpperCase() }}
    </div>

    <b-button
      v-if="!readOnly"
      class="btn blue m__t--15"
      @click="saveData">
      Update
    </b-button>
  </div>
</template>

<script>
/* eslint-disable no-unused-vars, no-console, max-len */
import { mapActions, mapState } from 'vuex';
import { jPrivRoles } from '@/privilage/roles/jPrivRoles';

export default {
  // eslint-disable-next-line
  name: 'jRole',
  components: {
  },
  mixins: [
    jPrivRoles,
  ],
  data() {
    return {
      isAdmin: true,
      isKepsek: true,
      dataRole: [],
    };
  },
  computed: {
  },
  watch: {
  },
  created() {
    this.getRole({ id_pegawai: this.$route.params.id }).then((res) => {
      this.dataRole = res.data;
    });
  },
  methods: {
    ...mapActions('jStoreKurikulum', ['getRole', 'updateRole']),

    saveData() {
      this.$swal({
        title: 'Update Role',
        text: 'Apakah anda yakin mengupdate data role pada pegawai ini ?',
        showCancelButton: true,
        confirmButtonText: 'Ya',
        cancelButtonText: 'Tidak',
      }).then((result) => {
        if (result.value) {
          this.updateRole(this.dataRole);
        }
      });
    },
  },
  validations() {
    return {
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/views/kurikulum/kepegawaian/tab-component/jRole.vue